import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from '@phosphor-icons/react';

const STORAGE_KEY = 'beeweddi_cookie_consent_v1';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      // Slight delay so it doesn't compete with first paint
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
    return undefined;
  }, []);

  const setChoice = (choice) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      choice,
      accepted_at: new Date().toISOString(),
    }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-2 left-2 right-2 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-md z-[60] bg-white border border-[#E8E1D5] shadow-xl rounded-md p-2.5 sm:p-5"
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-banner"
    >
      <div className="flex items-start gap-2 sm:gap-3">
        <div className="hidden sm:flex flex-shrink-0 w-9 h-9 rounded-full bg-brand-primary/10 items-center justify-center">
          <Cookie size={20} className="text-brand-primary" weight="duotone" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-medium text-xs sm:text-sm text-text-primary mb-0.5 sm:mb-1">We value your privacy</div>
          <p className="text-[10px] sm:text-xs text-text-secondary leading-snug sm:leading-relaxed line-clamp-2 sm:line-clamp-none">
            BeeWeddy uses essential cookies to keep you signed in and remember your preferences.
            We do <strong>not</strong> use ad-tracking. See our{' '}
            <Link to="/privacy-policy" className="text-brand-primary underline" data-testid="cookie-privacy-link">
              Privacy Policy
            </Link>.
          </p>
          <div className="flex flex-wrap gap-1.5 sm:gap-2 mt-1.5 sm:mt-3">
            <button
              type="button"
              onClick={() => setChoice('accepted')}
              className="px-2.5 sm:px-4 py-1 sm:py-2 bg-brand-primary text-sand-50 rounded-none text-[10px] sm:text-xs font-bold hover:bg-[#A84A38] transition-colors"
              data-testid="cookie-accept-btn"
            >
              Accept Essential
            </button>
            <button
              type="button"
              onClick={() => setChoice('rejected')}
              className="px-2.5 sm:px-4 py-1 sm:py-2 border border-[#E8E1D5] text-text-primary rounded-none text-[10px] sm:text-xs font-bold hover:bg-sand-100 transition-colors"
              data-testid="cookie-reject-btn"
            >
              Reject
            </button>
          </div>
        </div>
        <button
          type="button"
          onClick={() => setChoice('dismissed')}
          aria-label="Dismiss"
          className="flex-shrink-0 text-text-secondary hover:text-text-primary p-1"
          data-testid="cookie-dismiss-btn"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
